import type { CSSProperties } from 'react';
import { ICON_REGISTRY } from '../../components/surface/content/icon-registry';

interface IconProps {
  name: string;
  color?: string;
  size?: string;
  className?: string;
  style?: CSSProperties;
}

const SIZE_MAP: Record<string, number> = {
  sm: 16,
  md: 20,
  lg: 28,
};

function toPascalCase(str: string): string {
  return str
    .split(/[-_\s]+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join('');
}

export function IconView({ name, color, size = 'md', className, style }: IconProps) {
  const iconSize = SIZE_MAP[size] ?? SIZE_MAP.md;
  const pascalName = toPascalCase(name);
  const LucideIcon = ICON_REGISTRY[pascalName];

  if (!LucideIcon) {
    return (
      <span title={`Unknown icon: ${name}`} className={className} style={style}>
        ?
      </span>
    );
  }

  return <LucideIcon size={iconSize} color={color} className={className} style={style} />;
}
